import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import { GroupIcon } from 'components/CustomSVG';
import { updateCustomerPushCartApi } from 'api';
import { useStyles } from '../styles';
import QuoteSeriesNameModal from './QuoteSeriesNameModal';


const GroupQuotePlanSeriesButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openNewNameModal, setOpenNewNameModal] = useState<boolean>(false);

  const {
    quotePlanSelectedSeriesIds,
    quotePlan,
    customerPushCart,
    currentQuoteCustomer
  } = useSelector((state: IReduxState) => state.quote);

  const isDisabled = quotePlanSelectedSeriesIds.length < 2;

  const validNames = quotePlan.flatMap((quote) => {
    if (quotePlanSelectedSeriesIds.includes(quote._id)) {
      return quote.name;
    }

    return [];
  });

  const handleCreateNewSeries = async (name) => {
    let groupIndex;

    const updatedQuotePlan = quotePlan.reduce((acc, series, index) => {
      if (quotePlanSelectedSeriesIds.includes(series._id)) {
        if (groupIndex === undefined) {
          groupIndex = index;
          acc[groupIndex] = series;
        } else {
          const group = acc[groupIndex];
          acc[groupIndex] = {...group, name, selectedItemIds: [...group.selectedItemIds, ...series.selectedItemIds], selectedItems: [...group.selectedItems, ...series.selectedItems]};
        }
      } else {
        acc.push(series);
      }

      return acc;
    }, []);

    const updatedPushCart = {...customerPushCart, customer: currentQuoteCustomer, treatments: updatedQuotePlan };
    await updateCustomerPushCartApi({ dispatch, pushCartId: customerPushCart._id, pushCart: updatedPushCart });
    setOpenNewNameModal(false);
  };

  return (
    <div className={`${isDisabled ? 'cursor-not-allowed' : ''}`}>
      <Button
        variant="outlined"
        className={`${classes.quoteCTAButton} mr-2`}
        disabled={isDisabled}
        onClick={() => setOpenNewNameModal(true)}
      >
        <GroupIcon className="mr-1" muted={isDisabled} />
        Group as Series
      </Button>
      {openNewNameModal &&
        <QuoteSeriesNameModal
          open={openNewNameModal}
          setOpen={setOpenNewNameModal}
          title="Create New Name"
          onSave={handleCreateNewSeries}
          validNames={validNames}
        />
      }
    </div>
  );
};

export default GroupQuotePlanSeriesButton;
